import * as dateFnsLocales from 'date-fns/locale';
import type { Locale } from 'date-fns';
import getFormattingLocale from './getFormattingLocale';

/**
 * Resolves the current app locale to a date-fns Locale object.
 * Tries the exact locale (e.g. 'es-419' -> 'es419'), then falls back to
 * the base language (e.g. 'es'), then to enUS if neither is available
 * in date-fns.
 */
function getDateFnsLocale(): Locale {
  const locale = getFormattingLocale();
  const localeCode = locale.replace('-', '');
  const baseLanguage = locale.split('-')[0];

  return (
    dateFnsLocales[localeCode as keyof typeof dateFnsLocales] ||
    dateFnsLocales[baseLanguage as keyof typeof dateFnsLocales] ||
    dateFnsLocales.enUS
  );
}

export default getDateFnsLocale;
